import DapDSSnackbarMessage from './snackbar-message.component'

export * from './snackbar-message.component'
export default DapDSSnackbarMessage

DapDSSnackbarMessage.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-snackbar-message': DapDSSnackbarMessage
  }
}
